import { GET_DEVICE, RESET_DEVICE_ERROR, RESET_USER, ADD_PLANT_TO_SENSOR, REMOVE_PLANT_FROM_SENSOR, ADD_SENSOR, REMOVE_SENSOR } from '../actions'

const INITIAL_STATE = {}

function DevicesReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_DEVICE:
        case ADD_PLANT_TO_SENSOR:
        case REMOVE_PLANT_FROM_SENSOR:
        case ADD_SENSOR:
            return {
                ...state,
                [action.payload.body ? action.payload.body.uuid : 'error']: action.payload.body || action.payload,
            }
        case RESET_DEVICE_ERROR:
            return {
                ...state,
                error: null,
            }
        case REMOVE_SENSOR:
            return {
                ...state,
                [action.payload.body ? action.meta.sensorId : 'error']: null,
            }
        case RESET_USER:
            return INITIAL_STATE
        default: return state
    }
}

export default DevicesReducer



// WEBPACK FOOTER //
// ./src/reducers/devices.js